<template>
    <div class="navigation-search">
        <div class="navigation-search__searched">
            <div class="navigation-search__frequent-terms">
                <h4>Frequently Searched</h4>
                <ul>
                    <li v-for="frequent in frequentSearches" :key="frequent">
                        <a :href="`/search-results?query=${frequent}`">{{ frequent }}</a>
                    </li>
                </ul>
            </div>
            <div class="navigation-search__recent-terms" v-if="previousSearches && previousSearches.length > 0">
                <h4>Previous Searches</h4>
                <ul>
                    <li v-for="search in previousSearches.slice(0, 5)" :key="search">
                        <a :href="`/search-results?query=${encodeURIComponent(decode(search))}`">{{ decode(search) }}</a>
                    </li>
                </ul>
            </div>
            <div class="navigation-search__clear-wrapper">
                <div class="navigation-search__visited-clear" @click="clearSearches">Clear Searches</div>
            </div>
        </div>
        <div class="navigation-search__form-wrapper">
            <div class="navigation-search__form">
                <div class="navigation-search__input-wrapper">
                    <form action="/search-results" ref="searchForm">
                        <input type="text" ref="searchInput" v-model="searchQuery" @input="runTrigger"
                            placeholder="Enter name or keyword" name="query" />
                        <button title="Search" type="submit">
                            <i class="icon-return"></i>
                        </button>
                        <div class="search-autocomplete" v-on:mouseleave="showResults = false"
                            v-if="showResults && results.documents && results.documents.length > 0">
                            <div class="search-autocomplete__suggestion" @click="runSearch(suggestion.suggestion)"
                                v-for="(suggestion, index) in results.documents" :key="index">
                                {{ suggestion.suggestion }}
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="navigation-search__visited">
                <div class="navigation-search__visited-title-wrapper">
                    <div class="navigation-search__visited-title">Recently Visited</div>

                </div>
                <div>
                    <div class="navigation-search__visited-results" v-if="recentlyVisited && recentlyVisited.length > 0">
                        <template v-for="(recent, index) in resultsSorted">
                            <template v-if="index < 6">
                                <ProfessionalSearchCard v-if="recent.type === 'professional'" :key="index + '-1'"
                                    :professional-name="recent.professionalName" :page-title="recent.pageTitle"
                                    :title="recent.title" :profile-image="recent.profileImage"
                                    :direct-phone="recent.directPhone" :office-email="recent.officeEmail"
                                    :linked-in-url="recent.linkedInUrl" :url="recent.url" />
                                <LocationSearchCard v-else-if="recent.type === 'location'" :key="index + '-2'"
                                    :pageTitle="recent.pageTitle" :directPhone="recent.directPhone"
                                    :getDirectionsLink="recent.getDirectionsLink" :url="recent.url" />
                                <ArticleSearchCard v-else-if="recent.type === 'article' || recent.type === 'insight'"
                                    :key="index + '-3'" :pageTitle="recent.pageTitle" :category="recent.category"
                                    :published="recent.published" :url="recent.url" />
                                <PageCard v-else :key="index + '-4'" :pageTitle="recent.pageTitle" :url="recent.url" />
                            </template>
                        </template>
                    </div>
                    <div v-else>
                        <div class="navigation-search__empty">None Available</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import RecentlyVisited from "../../services/recentlyVisited"
import ProfessionalSearchCard from "./SearchCards/ProfessionalSearchCard"
import LocationSearchCard from "./SearchCards/LocationSearchCard"
import ArticleSearchCard from "./SearchCards/ArticleSearchCard"
import PageCard from "./SearchCards/PageCard"
import axios from 'axios';

export default {
    props: ["frequentSearches"],
    components: {
        ProfessionalSearchCard,
        LocationSearchCard,
        ArticleSearchCard,
        PageCard
    },
    data() {
        return {
            previousSearches: [],
            recentlyVisited: [],
            timer: null,
            results: {
                documents: []
            },
            searchInput: null,
            searchQuery: "",
            showResults: false,
        }
    },
    mounted() {
        this.previousSearches = JSON.parse(window.localStorage.getItem("previous-searches") ?? "[]").reverse();
        this.getRecentlyVisited();
        this.$nextTick(() => {
            this.$refs.searchInput.focus();
        });

        let self = this;
        document.querySelector("body").addEventListener("click", function (event) {
            self.showResults = false;
        });
    },
    computed: {
        resultsSorted: function () {
            return this.recentlyVisited.sort((a, b) => b.sort - a.sort);
        }
    },
    methods: {
        decode: function (str) {
            let txt = new DOMParser().parseFromString(str, "text/html");
            return txt.documentElement.textContent;
        },
        clearSearches: function () {
            this.previousSearches = [];
            this.recentlyVisited = [];
            window.localStorage.removeItem("recently-visited");
            window.localStorage.removeItem("previous-searches");
        },
        getRecentlyVisited: async function () {
            this.recentlyVisited = [];
            try {
                const response = await RecentlyVisited.recentlyVisited();
                this.recentlyVisited = response.content;
                this.loading = false;
            } catch (error) {
                this.error = true;
                this.loading = false;
            }
        },

        runSearch(suggestion) {
            this.searchQuery = suggestion;
            this.$nextTick(() => {
                this.$refs.searchForm.submit();
            });
        },
        runTrigger() {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                if (this.searchQuery && this.searchQuery.length > 3) {
                    axios.post("https://o-melveny-site-search.ent.us-central1.gcp.cloud.es.io/api/as/v1/engines/umbraco-search-production/query_suggestion", {
                        query: this.searchQuery,
                        types: {
                            documents: {
                                fields: [
                                    "title",
                                    "full_name",
                                    "professional_languages",
                                    "professional_education",
                                    "professional_admissions",
                                    "professional_honors",
                                    "professional_activities",
                                    "professional_corporate_experience",
                                ]
                            }
                        },
                        size: 5
                    }, {
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer search-p5qfzquhtw1okw3mibb219ja'
                        }
                    })
                        .then((response) => {
                            this.results = response.data.results;
                            this.showResults = true;
                        })
                        .catch((err) => {
                            this.showResults = false;
                        });
                }
            }, 100)


        }
    }

}
</script>

